export const pxToRem = (px) => {
    const num = px.replace('px', '');
    const value = Number(num) / 16;
    return `${value}rem`;
  };